<template>
  <transition name="fade" :duration="{enter: 400}">
    <div
      class="text-center mb-14 onborading-box"
      v-if="isShowObb"
    >
      <div v-if="isShowObbPresentation">
        <img src="@/assets/images/onboarding/my-presentation.svg" alt="" class="img-onboarding">
        <div class="mb-1 text-xl font-bold">
          {{ $i18nPresenter.t('Let’s have a great time!') }}
        </div>
        <div class="mb-6 text-base-80">
          <p>
            {{ $i18nPresenter.t('Add your own slides, or pick a template. It’s actually quite easy!') }}
          </p>
        </div>
        <div v-if="!shared">
          <aha-button
            has-margin-right
            variant="primary"
            size="xl"
            class="inline-block mb-4 3xs:mr-3 btn-action-presentation live-demo-btn"
            @click="addNewPresentation()"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>{{ $i18nPresenter.t('New Presentation') }}</span>
          </aha-button>

          <aha-button
            variant="white"
            size="xl"
            @click="openImportModal()"
            icon-name="import"
            :submitting="isImportingSlides"
            class="relative inline-block mb-4 btn-import btn-action-presentation"
            :class="{
              'pl-10': isImportingSlides
            }"
          >
            <aha-spinner v-if="isImportingSlides" class="absolute left-4" />
            {{ $i18nPresenter.t('Import PowerPoint') }}
          </aha-button>
        </div>
      </div>
      <div v-if="isShowObbTeam">
        <img src="@/assets/images/onboarding/team-presentation.svg" alt="" class="img-onboarding">
        <div class="mb-1 text-xl font-bold">
          {{ $i18nPresenter.t('Create fun and engaging moments, together.') }}
        </div>
        <div class="mb-6 text-base-80">
          <p>
            {{ $i18nPresenter.t('Team presentations created here will be accessible to all team members.') }}
          </p>
        </div>
        <div v-if="!shared">
          <aha-button
            has-margin-right
            variant="primary"
            size="xl"
            class="flex justify-center
            inline-block mb-4 3xs:mr-3
            btn-action-presentation btn-new-presentation-team"
            :class="'ml-auto mr-auto' "
            @click="addNewTeamPresentation()"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>{{ $i18nPresenter.t('New Presentation') }}</span>
          </aha-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import constants from '@/constant'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  props: {
    shared: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      currentUser: (state) => state.currentUser,
    }),
    isShowObb() {
      if (typeof (this.currentUser.isPlayingDemoEnabled) === 'boolean') return true
      if (this.$store.state.plan.group === 'white-label') return true
      return false
    },
    isShowObbPresentation() {
      return this.$route.name === 'Presentations'
    },
    isShowObbTeam() {
      return this.$route.name === 'Team'
    },

  },
  methods: {
    openImportModal() {
      this.$store.state.openImportModal = true
      this.trackEvent('Import > Open modal')
    },
    addNewPresentation() {
      this.createNewPresentation('Onboarding Box')
    },
    addNewTeamPresentation() {
      this.createNewPresentation('Onboarding Box')
    },
    trackEvent(label) {
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        label,
      )
    },
    async getLiveDemo() {
      this.$router.push({ name: 'PresentationPlayDemo' })
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        'Live demo > Open live demo',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.img-onboarding {
  margin: 0 auto;
}

@media (max-width: 400px) {
  .btn-action-presentation {
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .onborading-box {
    margin-bottom: 100px;
  }
}

.btn-import {
  &::v-deep {
    svg {
      margin-bottom: 3px;
    }
  }
}

.live-demo-btn {
  width: 173px;
}
.btn-new-presentation-team {
  width: 173px;
  margin-left: auto;
  margin-right: auto;
}
</style>
